import { createReducer } from '@reduxjs/toolkit';
import { SharingLinkShape } from './model';
import * as sharingLinkActions from './actions';

const initial: SharingLinkShape = {
  links: [],
  loading: false,
  selectedIds: [],
  linkModal: {
    visible: false,
    inProgress: false,
    link: undefined,
  },
  searchQuery: '',
  sorter: {},
  pagination: { pageSize: 200 },
  isActiveFilter: undefined,
};

export const sharingLinkReducer = createReducer<SharingLinkShape>(initial, (builder) =>
  builder
    .addCase(sharingLinkActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(sharingLinkActions.linksChanged, (s, a) => {
      s.links = a.payload.links;
      s.pagination.total = a.payload.total;
    })
    .addCase(sharingLinkActions.linksSelected, (s, a) => {
      s.selectedIds = a.payload.ids;
    })
    .addCase(sharingLinkActions.linkChanged, (s, a) => {
      const index = s.links.findIndex((link) => link.id === a.payload.link.id);
      if (index !== -1) {
        s.links[index] = a.payload.link;
      }
    })
    .addCase(sharingLinkActions.linkModalSetVisible, (s, a) => {
      s.linkModal.visible = a.payload.visible;
      if (a.payload.visible) {
        s.linkModal.link = a.payload.link;
      }
    })
    .addCase(sharingLinkActions.linkModalSetInProgress, (s, a) => {
      s.linkModal.inProgress = a.payload.inProgress;
    })
    .addCase(sharingLinkActions.searchQueryChanged, (s, a) => {
      s.searchQuery = a.payload.searchQuery;
      s.pagination.current = 1;
    })
    .addCase(sharingLinkActions.sorterChanged, (s, a) => {
      s.sorter = a.payload;
      s.pagination.current = 1;
    })
    .addCase(sharingLinkActions.isActiveFilterChanged, (s, a) => {
      s.isActiveFilter = a.payload.isActive;
      s.pagination.current = 1;
    })
    .addCase(sharingLinkActions.paginationChanged, (s, a) => {
      s.pagination.current = a.payload.current;
    }),
);
